import { memo } from 'react'
import { FormattedMessage } from 'react-intl'
import classNames from 'classnames'

import styles from './styles.module.scss'

const SectionWrapper = memo(
  ({
    children,
    className,
    title,
    titleId,
    titleComponent: TitleComponent = 'h4',
    wrapperClassName,
    ...props
  }) => {
    const sectionClassName = classNames(styles.section, className)

    const contentClassName = classNames(styles.content, wrapperClassName)

    return (
      <div className={sectionClassName} {...props}>
        <div className={contentClassName}>
          {(title || titleId) && (
            <TitleComponent className={styles.title}>
              {titleId ? <FormattedMessage id={titleId} /> : title}
            </TitleComponent>
          )}
          {children}
        </div>
      </div>
    )
  }
)

export default SectionWrapper
